import React from "react"
import { useEffect, useState } from "react"

import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Modal
} from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast"
import API from "components/Apis/API"
import $ from "jquery"

const BonusCreateModal = (props) => {

  const [showModal, setShowModal] = useState(false)
  const handleCloseModal = () => setShowModal(false)
  const handleShowModal  = () => setShowModal(true)

  const createPeriod = async (e) => {
    e.preventDefault();
    const formData = new FormData($("#createPeriodForm")[0])
    const toastId = toast.loading("Creating period...")
    const url = "admin/bonus/periods/create"
    const response = await API.postData(url, formData)
    if (response.status == 1)
    {
      props.setPeriods(response.data.periods)
      props.setPrimary(response.data.primary)
    }
    toast.dismiss(toastId)
    props.close()
  }
  useEffect(() => {
    console.log(2)
  }, [])


  return (
    <>
      <Toaster position='bottom-right' />
      <Modal
        className='all-orders-order-history'
        show={props.show}
        cancel={props.close}
        hide={props.close}
      >
        <Modal.Header className='pt-0'>
          <Modal.Title>Create Period</Modal.Title>
        </Modal.Header>
        <form onSubmit={createPeriod} id="createPeriodForm">
          <Modal.Body className='pt-0'>
              
                  <Row>
                    <Col md="6">
                          <div className="form-group">
                              <label>Name</label>
                              <input className="form-control" name="name" type="text"  required/>
                          </div>
                      </Col>
                      <Col md="6">
                          <div className="form-group">
                              <label>Description</label>
                              <input className="form-control" name="description" type="text" />
                          </div>
                      </Col>
                      <Col md="6">
                          <div className="form-group">
                              <label>Start Date</label>
                              <input className="form-control" name="start_date" type="date" required />
                          </div>
                      </Col>
                      <Col md="6">
                          <div className="form-group">
                              <label>End Date</label>
                              <input className="form-control" name="end_date" type="date" required />
                          </div>
                      </Col>
                      <Col md="6">
                        
                          <div className="form-group">
                              <label>Copy Structure From</label>
                              <select name="copy_period_id" className="form-control">
                              {props.Primary.id != undefined ? (
                                <option value={props.Primary.id}>Primary ({props.Primary.name})</option>
                              ) :
                              (<></>)}
                              <option value="0">None</option>
                              {props.Periods.map((row, i) => (
                                  <option value={row.id}>{row.name} ({row.start_date} - {row.end_date})</option>
                              ))}
                              </select>
                          </div>
                      </Col>
                  </Row>
              
          </Modal.Body>
          <Modal.Footer>
              <Button onClick={props.close}>
              Close
            </Button>
            <Button type="submit">
              Save
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}

export default BonusCreateModal;
